import WeddingEventSocialDetails from './WeddingEventSocialDetails';

export default WeddingEventSocialDetails;
